import {
  SET_INVITE_ID,
  SET_CANDIDATE_EMAIL,
  SET_CANDIDATE_COLLEGE_NAME,
  SET_CANDIDATE_MOBILE,
  SET_CANDIDATE_RESUME,
  SET_CANDIDATE_IMAGE_STATUS,
  SET_CANDIDATE_IMAGE,
  SET_CANDIDATE_MODE,
  SET_CANDIDATE_NAME,
  SET_EXTRA_FIELDS,
  SET_CANDIDATE_EXIT,
  SET_CANDIDATE_TAB_SWITCH,
  SET_TOTAL_TIME,
  SET_CANDIDATE_SHUFFLE,
  SET_CANDIDATE_LOGOUT,
  SET_START_TIME,
  SET_CANDIDATE_RETAKE,
  SET_RESUME_DATE,
  RESET_CANDIDATE_COUNTS,
} from "./actionTypes";

const initialState = {
  id: null,
  email: null,
  name: null,
  collegeName: null,
  mobile: null,
  resume: null,
  image: null,
  status: null,
  mode: null,
  fields: null,
  count: 0,
  tab: 0,
  time: null,
  shuffle: null,
  logout: null,
  startTime: null,
  retake: false,
  resumeDate: null,
};

const candidateReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_INVITE_ID:
      return {
        ...state,
        id: action.payload,
      };
    case SET_CANDIDATE_EMAIL:
      return {
        ...state,
        email: action.payload,
      };
    case SET_CANDIDATE_MOBILE:
      return {
        ...state,
        mobile: action.payload,
      };
    case SET_CANDIDATE_NAME:
      return {
        ...state,
        name: action.payload,
      };
    case SET_CANDIDATE_COLLEGE_NAME:
      return {
        ...state,
        collegeName: action.payload,
      };
    case SET_CANDIDATE_RESUME:
      return {
        ...state,
        resume: action.payload,
      };
    case SET_CANDIDATE_IMAGE:
      return {
        ...state,
        image: action.payload,
      };
    case SET_CANDIDATE_IMAGE_STATUS:
      return {
        ...state,
        status: action.payload,
      };
    case SET_CANDIDATE_MODE:
      return {
        ...state,
        mode: action.payload,
      };
    case SET_EXTRA_FIELDS:
      return {
        ...state,
        fields: action.payload,
      };
    case SET_CANDIDATE_EXIT:
      return {
        ...state,
        count: action.payload,
      };
    case SET_CANDIDATE_TAB_SWITCH:
      return {
        ...state,
        tab: action.payload,
      };

    case SET_START_TIME:
      return {
        ...state,
        startTime: action.payload,
      };
    case SET_TOTAL_TIME:
      return {
        ...state,
        time: action.payload,
      };
    case SET_CANDIDATE_SHUFFLE:
      return {
        ...state,
        shuffle: action.payload,
      };
    case SET_CANDIDATE_LOGOUT:
      return {
        ...initialState,
        logout: null,
      };

    case SET_CANDIDATE_RETAKE:
      return {
        ...state,
        retake: action.payload,
      };
    case SET_RESUME_DATE:
      return {
        ...state,
        resumeDate: action.payload,
      };

    case RESET_CANDIDATE_COUNTS:
      return {
        ...state,
        count: 0,
        tab: 0,
        time: 0,
      };

    default:
      return state;
  }
};

export default candidateReducer;
